<div>
    <div class="d-flex align-items-center">
        <input
            [id]="id"
            [name]="name"
            [value]="value"
            [checked]="checked"
            (change)="onChange()"
            (blur)="onBlur()"
            [disabled]="disabled"
            [class.is-invalid]="invalid"
            class="form-check-input"
            type="radio"
        />
        <label [for]="id" (click)="onLabelClick($event)" class="form-check-label ms-1">{{ label }}</label>
    </div>
    <small *ngIf="hint" class="radio-hint fst-italic">{{ hint }}</small>
</div>
